/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { MoreVertical20Regular } from '@fluentui/react-icons';
import { COPILOT_MAX_WIDTH, COPILOT_WIDTH } from './utils';

const useResizerHandleStyles = makeStyles({
  resizerHandle: {
    width: '20px',
    height: '100%',
    cursor: 'col-resize',
    display: 'flex',
    zIndex: 2,
    alignItems: 'center',
    left: 0,
  },
  resizerHandleLine: {
    width: '2px',
    height: '100%',
    backgroundColor: '#D1D1D1',
  },
  resizerHandleLineDragging: {
    backgroundImage: 'linear-gradient(272deg, #6DB4AD -71.21%, #1D77BB 95.74%)',
  },
  resizerIcon: {
    marginLeft: '-4px',
    color: '#D1D1D1',
  },
  resizerIconDragging: {
    color: '#0F6CBD',
  },
});

interface IResizerHandleProps {
  isDragging: boolean;
}

export const ResizerHandle: React.FC<IResizerHandleProps> = ({ isDragging }) => {
  const styles = useResizerHandleStyles();

  return (
    <div
      id="copilot-resizer-handle"
      className={styles.resizerHandle}
      role="separator"
      aria-orientation="vertical"
      aria-valuemin={COPILOT_WIDTH}
      aria-valuemax={COPILOT_MAX_WIDTH}
      aria-label="Copilot resizer"
    >
      <div className={mergeClasses(styles.resizerHandleLine, isDragging && styles.resizerHandleLineDragging)} />
      <MoreVertical20Regular
        className={mergeClasses(styles.resizerIcon, isDragging && styles.resizerIconDragging)}
        aria-hidden
      />
    </div>
  );
};
